<template>
 <div class="visitor-behavior">
 <el-row :gutter="20" class="card-row">
 <el-col :span="6">
 <div class="stat-card blue">
 <div class="stat-card-top">
 <div class="stat-card-icon"><i class="el-icon-document"></i></div>
 <div class="stat-card-info">
 <div class="stat-card-value">{{ summary.avg_pages_per_visit || 0 }}</div>
 <div class="stat-card-label">平均浏览页数</div>
 </div>
 </div>
 <div class="stat-card-sub">每位访客平均浏览页面数</div>
 </div>
 </el-col>
 <el-col :span="6">
 <div class="stat-card green">
 <div class="stat-card-top">
 <div class="stat-card-icon"><i class="el-icon-time"></i></div>
 <div class="stat-card-info">
 <div class="stat-card-value">{{ formatDuration(summary.avg_duration) }}</div>
 <div class="stat-card-label">平均访问时长</div>
 </div>
 </div>
 <div class="stat-card-sub">多页访问的访客平均停留</div>
 </div>
 </el-col>
 <el-col :span="6">
 <div class="stat-card orange">
 <div class="stat-card-top">
 <div class="stat-card-icon"><i class="el-icon-user"></i></div>
 <div class="stat-card-info">
 <div class="stat-card-value">{{ summary.total_visitors || 0 }}</div>
 <div class="stat-card-label">总访客数</div>
 </div>
 </div>
 <div class="stat-card-sub">新访客 {{ summary.new_visitors || 0 }} / 回访客 {{ summary.returning_visitors || 0 }}</div>
 </div>
 </el-col>
 <el-col :span="6">
 <div class="stat-card red">
 <div class="stat-card-top">
 <div class="stat-card-icon"><i class="el-icon-view"></i></div>
 <div class="stat-card-info">
 <div class="stat-card-value">{{ summary.total_page_views || 0 }}</div>
 <div class="stat-card-label">总浏览量</div>
 </div>
 </div>
 <div class="stat-card-sub">跳出率 {{ summary.bounce_rate || 0 }}%</div>
 </div>
 </el-col>
 </el-row>

 <el-row :gutter="20" class="card-row">
 <el-col :span="12">
 <div class="chart-card">
 <div class="chart-header">
 <el-date-picker
 v-model="dateRange"
 type="daterange"
 range-separator="至"
 start-placeholder="开始日期"
 end-placeholder="结束日期"
 value-format="yyyy-MM-dd"
 :picker-options="pickerOptions"
 @change="loadAll"
 />
 <el-select v-model="websiteId" placeholder="全部网站" clearable size="small" style="width:180px; margin-left:12px" @change="loadAll">
 <el-option label="全部网站" :value="0" />
 <el-option v-for="w in websites" :key="w.id" :label="w.name" :value="w.id" />
 </el-select>
 <el-button type="primary" size="small" @click="loadAll" style="margin-left:12px">刷新</el-button>
 </div>
 <div ref="depthChart" class="chart-body"></div>
 </div>
 </el-col>
 <el-col :span="12">
 <div class="chart-card">
 <div class="chart-header"><span class="chart-title">新老访客对比</span></div>
 <div ref="newReturnChart" class="chart-body"></div>
 </div>
 </el-col>
 </el-row>

 <el-row :gutter="20" class="card-row">
 <el-col :span="24">
 <div class="chart-card">
 <div class="chart-header"><span class="chart-title">访客会话明细</span></div>
 <div style="padding: 12px 20px;">
 <el-table :data="visitorList" stripe style="width: 100%" size="small">
 <el-table-column type="index" label="#" width="50" />
 <el-table-column prop="ip" label="IP地址" width="130" />
 <el-table-column prop="ip_location" label="归属地" width="120" show-overflow-tooltip />
 <el-table-column prop="page_views" label="浏览次数" width="80" align="center" sortable />
 <el-table-column prop="distinct_pages" label="不同页面" width="80" align="center" sortable />
 <el-table-column label="访问时长" width="100" align="center">
 <template slot-scope="{ row }">{{ formatDuration(row.duration) }}</template>
 </el-table-column>
 <el-table-column prop="first_visit" label="首次访问" width="155">
 <template slot-scope="{ row }">{{ formatTime(row.first_visit) }}</template>
 </el-table-column>
 <el-table-column prop="last_visit" label="最后访问" width="155">
 <template slot-scope="{ row }">{{ formatTime(row.last_visit) }}</template>
 </el-table-column>
 <el-table-column label="访客类型" width="90" align="center">
 <template slot-scope="{ row }">
 <el-tag :type="row.is_new_visitor ? 'success' : 'warning'" size="mini">
 {{ row.is_new_visitor ? '新访客' : '回访客' }}
 </el-tag>
 </template>
 </el-table-column>
 </el-table>
 <div style="margin-top:16px;text-align:right">
 <el-pagination
 @current-change="handlePageChange"
 :current-page="page"
 :page-size="pageSize"
 :total="total"
 layout="total, prev, pager, next, jumper"
 />
 </div>
 </div>
 </div>
 </el-col>
 </el-row>
 </div>
</template>

<script>
import * as echarts from 'echarts';
import { statsApi, websiteApi } from '../api';
import dayjs from 'dayjs';

export default {
 name: 'VisitorBehavior',
 data() {
 return {
 dateRange: [dayjs().subtract(30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
 websiteId: 0,
 websites: [],
 summary: {},
 depthDist: {},
 visitorList: [],
 page: 1,
 pageSize: 20,
 total: 0,
 charts: {},
 pickerOptions: {
 shortcuts: [
 { text: '今天', onClick(picker) { const d = dayjs().format('YYYY-MM-DD'); picker.$emit('pick', [d, d]); } },
 { text: '近7天', onClick(picker) { picker.$emit('pick', [dayjs().subtract(6, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 { text: '近30天', onClick(picker) { picker.$emit('pick', [dayjs().subtract(29, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 { text: '本月', onClick(picker) { picker.$emit('pick', [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 ]
 }
 };
 },
 mounted() {
 this.loadWebsites();
 this.loadAll();
 window.addEventListener('resize', this.resizeCharts);
 },
 beforeDestroy() {
 window.removeEventListener('resize', this.resizeCharts);
 Object.values(this.charts).forEach(c => c && c.dispose());
 },
 methods: {
 async loadWebsites() {
 try {
 const res = await websiteApi.list({ page: 1, page_size: 100 });
 if (res.code === 0) this.websites = res.data.list;
 } catch (e) { console.error(e); }
 },
 async loadAll() {
 this.page = 1;
 this.loadData();
 },
 async loadData() {
 const [startDate, endDate] = this.dateRange || [];
 const params = { start_date: startDate, end_date: endDate, website_id: this.websiteId, page: this.page, page_size: this.pageSize };
 try {
 const res = await statsApi.visitorBehavior(params);
 if (res.code !== 0) return;
 this.summary = res.data.summary;
 this.depthDist = res.data.depth_distribution;
 this.visitorList = res.data.visitor_list.list;
 this.total = res.data.visitor_list.total;
 this.renderDepthChart();
 this.renderNewReturnChart();
 } catch (e) { console.error(e); }
 },
 handlePageChange(p) {
 this.page = p;
 this.loadData();
 },
 renderDepthChart() {
 const keys = Object.keys(this.depthDist);
 const values = Object.values(this.depthDist);
 const colors = ['#5b8def', '#6b9e72', '#d4905a', '#c87560'];
 this.$nextTick(() => {
 const el = this.$refs.depthChart;
 if (!el) return;
 if (this.charts.depth) this.charts.depth.dispose();
 this.charts.depth = echarts.init(el);
 this.charts.depth.setOption({
 tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)', backgroundColor: 'rgba(30,41,59,0.92)', borderColor: 'rgba(91,141,239,0.15)', textStyle: { color: '#fff', fontSize: 12 } },
 legend: { bottom: 5, textStyle: { fontSize: 12, color: '#64748b' } },
 series: [{
 type: 'pie', radius: ['38%', '62%'], center: ['50%', '42%'],
 data: keys.map((k, i) => ({ name: k, value: values[i], itemStyle: { color: colors[i] } })),
 label: { fontSize: 11, color: '#64748b', formatter: '{b}\n{d}%' },
 itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
 }]
 });
 });
 },
 renderNewReturnChart() {
 const data = [
 { name: '新访客', value: this.summary.new_visitors || 0, itemStyle: { color: '#6b9e72' } },
 { name: '回访客', value: this.summary.returning_visitors || 0, itemStyle: { color: '#d4905a' } },
 ];
 this.$nextTick(() => {
 const el = this.$refs.newReturnChart;
 if (!el) return;
 if (this.charts.newReturn) this.charts.newReturn.dispose();
 this.charts.newReturn = echarts.init(el);
 this.charts.newReturn.setOption({
 tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)', backgroundColor: 'rgba(30,41,59,0.92)', borderColor: 'rgba(91,141,239,0.15)', textStyle: { color: '#fff', fontSize: 12 } },
 legend: { bottom: 5, textStyle: { fontSize: 12, color: '#64748b' } },
 series: [{
 type: 'pie', radius: ['38%', '62%'], center: ['50%', '42%'],
 data, label: { fontSize: 12, color: '#64748b', formatter: '{b}\n{d}%' },
 itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
 }]
 });
 });
 },
 formatDuration(seconds) {
 const s = Number(seconds) || 0;
 if (s < 60) return s + '秒';
 const m = Math.floor(s / 60);
 const r = s % 60;
 if (m < 60) return m + '分' + (r > 0 ? r + '秒' : '');
 const h = Math.floor(m / 60);
 const rm = m % 60;
 return h + '时' + (rm > 0 ? rm + '分' : '');
 },
 formatTime(t) {
 if (!t) return '-';
 return dayjs(t).format('YYYY-MM-DD HH:mm:ss');
 },
 resizeCharts() {
 Object.values(this.charts).forEach(c => c && c.resize());
 },
 }
};
</script>

<style scoped>
.filter-bar { display: flex; align-items: center; margin-bottom: 18px; }
.card-row { margin-bottom: 18px; }
.card-row > .el-col { display: flex; }

.stat-card {
 background: #fff; border-radius: 8px; padding: 20px 22px;
 box-shadow: 0 1px 3px rgba(0,0,0,0.04); border: 1px solid #eef0f3;
 width: 100%; display: flex; flex-direction: column;
 border-left: 3px solid #e2e8f0; transition: box-shadow 0.2s;
}
.stat-card:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.06); }
.stat-card.blue { border-left-color: #5b8def; }
.stat-card.green { border-left-color: #6b9e72; }
.stat-card.orange { border-left-color: #d4905a; }
.stat-card.red { border-left-color: #c87560; }
.stat-card-top { display: flex; align-items: center; gap: 14px; }
.stat-card-icon { width: 40px; height: 40px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
.stat-card.blue .stat-card-icon { background: rgba(91,141,239,0.08); color: #5b8def; }
.stat-card.green .stat-card-icon { background: rgba(107,158,114,0.08); color: #6b9e72; }
.stat-card.orange .stat-card-icon { background: rgba(212,144,90,0.08); color: #d4905a; }
.stat-card.red .stat-card-icon { background: rgba(200,117,96,0.08); color: #c87560; }
.stat-card-info { flex: 1; }
.stat-card-value { font-size: 26px; font-weight: 600; color: #1e293b; line-height: 1.3; }
.stat-card-label { font-size: 13px; color: #64748b; margin-top: 2px; }
.stat-card-sub { font-size: 12px; color: #94a3b8; margin-top: auto; padding-top: 10px; border-top: 1px solid #f5f6f8; min-height: 20px; }

.chart-card { background: #fff; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.04); border: 1px solid #eef0f3; overflow: hidden; width: 100%; }
.chart-header { padding: 14px 20px; border-bottom: 1px solid #f0f1f3; display: flex; align-items: center; justify-content: space-between; }
.chart-title { font-size: 14px; font-weight: 600; color: #1e293b; }
.chart-body { height: 340px; padding: 12px; }
</style>
